import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout, trackCustomEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  external?: boolean;
  /** Short label used to identify which CTA was clicked in the pixel events. */
  location: string;
  className?: string;
}
export function CtaButton({
  href,
  children,
  external = false,
  location,
  className = ''
}: CtaButtonProps) {
  /* External CTAs point to the checkout: fire InitiateCheckout before the
     browser follows the link. Internal CTAs only scroll to the price block. */
  const handleClick = () => {
    if (external) {
      trackInitiateCheckout(location);
    } else {
      trackCustomEvent('ClickCTA', {
        location
      });
    }
  };
  return <a href={href} onClick={handleClick} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-accent px-4 py-3.5 text-center font-display text-[0.85rem] font-extrabold uppercase leading-tight tracking-wide text-white shadow-lg shadow-accent/30 transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-accent-dark hover:shadow-xl active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent sm:px-6 sm:py-4 sm:text-base ${className}`} data-id="element-47" data-mp="19as4sx5a3b8x">
      <span data-id="element-48" data-mp="3ovryivyzol7g">{children}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-49" data-mp="3sxltqoqf0x08" />
    </a>;
}